import axios from "../accounts/api/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
  const { setAuth } = useAuth();
  const { auth } = useAuth();
  const rToken = auth?.refreshToken;
  const refresh = async () => {
    const response = await axios.post(
      "/auth/jwt/refresh",
      { refresh: rToken },
      {
        withCredentials: true,
      }
    );
    setAuth((prev) => {
      return { ...prev, accessToken: response.data.access };
    });
    return response.data.access;
  };
  return refresh;
};

export default useRefreshToken;
